import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

import { settlementsQueryKey } from './useSettlements'
import type { SettlementDetail } from '../types'

export function useSettlementDetail({ id }: { id?: string }) {
  async function getSettlement() {
    const response = await apiClient.get<SettlementDetail>(
      SNA_PREFIX + `settlements/${id}`
    )

    return response.data
  }

  return useQuery({
    queryFn: getSettlement,
    enabled: !!id,
    queryKey: [...settlementsQueryKey, 'detail', id]
  })
}
